export enum OwnershipType {
  Unknown = 0,
  OwnCompany = 1,
  GroupCompany = 2,
  ThirdPartyLease = 3,
  NotReviewed = 4,
}

export const OWNERSHIP_STATUS_SUPPORTED_FROM_YEAR = 2026;

export const getRegistrationYear = (registratiejaar?: number | string | Date | { year?: () => number }): number => {
  if (typeof registratiejaar === 'number') {
    return registratiejaar;
  }

  if (typeof registratiejaar === 'string') {
    const fullYear = registratiejaar.match(/\d{4}/)?.[0];
    return Number(fullYear ?? registratiejaar);
  }

  if (registratiejaar instanceof Date) {
    return registratiejaar.getFullYear();
  }

  if (typeof registratiejaar?.year === 'function') {
    return registratiejaar.year();
  }

  return Number.NaN;
};

export const hasOwnershipStatus = (registratiejaar?: number | string | Date | { year?: () => number }): boolean => {
  const year = getRegistrationYear(registratiejaar);

  return Number.isFinite(year) && year >= OWNERSHIP_STATUS_SUPPORTED_FROM_YEAR;
};
